<template>
    <div class="app-container">
      <list ref="list">
        <template slot="toolbar-right">
         
        </template>
        <template slot="column">
          <el-table-column label="操作" fixed="right" align="center" width="80" >
            <template slot-scope="{row}">
              <el-button type="text" icon="el-icon-edit" @click="edit(row)"></el-button>
          
            </template>
          </el-table-column>
        </template>
      </list>
      <edit-dialog ref="editDialog" @close-saved="reload" />
    </div>
  </template>
  <script>
  import curdMixins from "@/mixins/curd";
  import list from "@/components/person/demoexecute/list";
  import editDialog from "@/components/person/demoexecute/editDialog";
  
  export default {
    name: "demoexecute",
    mixins: [curdMixins],
    components: {
      list,
      editDialog,
    },
    methods: {
      del(id) {
        this.$confirm("确认删除数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.list.delRange([id]);
          })
          .catch(() => {});
      },
      delRows() {
        let rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择要删除的数据");
          return;
        }
        this.$confirm("确认删除所选的数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let ids = rows.map((item) => {
              return item.RecordId;
            });
            this.$refs.list.delRange(ids);
          })
          .catch(() => {});
      },
    },
  };
  </script>